import { ActionIcon, Box, Flex, Group, ScrollArea, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import {
  IconUserCircle,
  IconFileCv,
  IconBriefcase2,
  IconX,
  IconChartLine,
  IconCode,
  IconFileText,
  IconUserQuestion,
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Logo } from '@/components';
import { LinksGroup } from '@/components/Navigation/Links/Links';

import classes from './Navigation.module.css';
import { SidebarState } from '@/types';



type NavigationProps = {
  onClose: () => void;
  sidebarState: SidebarState;
};

const Navigation = ({
  onClose,
  sidebarState,
}: NavigationProps) => {

  const tablet_match = useMediaQuery('(max-width: 768px)');
  const { t } = useTranslation();
  const navigationData = [
    {
      title: t('profile'),
      links: [
        { label: t('profile'), icon: IconUserCircle, link: '/' },
        { label: t('resume'), icon: IconFileCv, link: '/resume' },
      ],
    },
    {
      title: t('job_application'),
      links: [
        { label: t('job_posts'), icon: IconBriefcase2, link: '/job-posts' },
        { label: t('cover_letter'), icon: IconFileText, link: '/cover-letter' },
        { label: t('job_analytics'), icon: IconChartLine, link: '/job-analytics' },
      ],
    },
    {
      title: t('job_interview'),
      links: [
        { label: t('technical_questions'), icon: IconCode, link: '/technical-questions' },
        { label: t('behavioural_questions'), icon: IconUserQuestion, link: '/behavioural-questions' },
      ],
    },
  ];
  const links = navigationData.map((m) => (
    <Box key={m.title} pl={0} mb={sidebarState === 'mini' ? 0 : 'md'}>
      {sidebarState !== 'mini' && (
        <Text
          tt="uppercase"
          size="xs"
          pl="md"
          fw={500}
          mb="sm"
          className={classes.linkHeader}
        >
          {m.title}
        </Text>
      )}
      {m.links.map((item) => (
        <LinksGroup
          key={item.label}
          {...item}
          isMini={sidebarState === 'mini'}
          closeSidebar={() => {
            setTimeout(() => {
              onClose();
            }, 250);
          }}
        />
      ))}
    </Box>
  ));

  return (
    <div className={classes.navbar} data-sidebar-state={sidebarState}>
      <div className={classes.header}>
        <Flex justify="space-between" align="center" gap="sm">
          <Group
            justify={sidebarState === 'mini' ? 'center' : 'space-between'}
            style={{ flex: tablet_match ? 'auto' : 1 }}
          >
            <Logo className={classes.logo} showText={sidebarState !== 'mini'} />
          </Group>
          {tablet_match && (
            <ActionIcon onClick={onClose} variant="transparent">
              <IconX color="white" />
            </ActionIcon>
          )}
        </Flex>
      </div>

      <ScrollArea className={classes.links}>
        <div className={classes.linksInner} data-sidebar-state={sidebarState}>
          {links}
        </div>
      </ScrollArea>
    </div>
  );
};

export default Navigation;